module.exports = __webpack_public_path__ + "static/media/zostelLogo.4fabc35c.svg";